import React from "react";
import MonthPicker from "@/components/search-filters/month-picker";
import FilterBox from "@/components/search-filters/filter-box";
import {Month} from "@/types/dto/search-filters/month-picker";
import {useTranslations} from "next-intl";
import {Box, Typography} from "@mui/material";

interface MonthFilterProps {
  months: Month[];
  selectedMonths: string[];
  onChange?: (data: Record<string, string>) => void;
  clearMonths?: (fieldName: string) => void;
}

const MonthFilter = ({
  months,
  onChange,
  clearMonths,
  selectedMonths
}: MonthFilterProps) => {
  const t = useTranslations("SEARCH");
  return (
    <FilterBox name={t("When")}>
      <Box sx={{display: "flex", flexDirection: "column", justifyContent: {xs: "center", legacyDesktop: "flex-start"}}}>
          <Typography
            variant="body2"
            sx={{ mb: "1.2rem" }}
            data-testid="month-filter-subtitle"
          >
            {t("Select departure months")}
          </Typography>
        <MonthPicker months={months} onChange={onChange} clearMonths={clearMonths} selectedMonths={selectedMonths} />
      </Box>
    </FilterBox>
  );
};

export default MonthFilter;